/**
 * Plain-text forms of TeX for accessible names. KaTeX marks its visible glyphs
 * `aria-hidden`, so an element whose only content is math (a table header
 * `$m_l$`, an answer option `$E=h\nu$`) needs a name derived from the source.
 */

/** `\Theta(\theta)` → "Theta(theta)"; `h\nu` → "h nu"; `m_l` → "m_l". */
export function readableTex(tex: string): string {
  return tex
    .replace(/([A-Za-z0-9])\\([A-Za-z]+)/g, "$1 $2")
    .replace(/[${}\\]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

const MATH_SEGMENT = /\$\$?[^$]+?\$\$?/g;

/**
 * Readable form of a content string that is nothing but math, or `undefined`
 * when it has any prose — a `<label>` with prose already names itself, and an
 * `aria-label` would only drop the math from that name.
 */
export function mathOnlyReadable(markdown: string): string | undefined {
  const segments = markdown.match(MATH_SEGMENT);
  if (!segments || markdown.replace(MATH_SEGMENT, "").trim() !== "") return undefined;
  return segments.map(readableTex).join(" ");
}
